module.exports = __webpack_public_path__ + "media/unipod/tanking_the_pod-d8fe62ff.jpg";